import { objectWithoutProperties as _objectWithoutProperties } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
var AlertDisable = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.051 3.77A6 6 0 0118 9v4a1 1 0 102 0V9A8 8 0 008.069 2.03a1 1 0 00.982 1.74zM14.586 16L6.168 7.582A6.006 6.006 0 006 9v5c0 .729-.195 1.412-.535 2h9.12zm2 2H2c-1.333 0-1.333-2 0-2a2 2 0 002-2V9.001a8 8 0 01.582-3.005L.292 1.707A1 1 0 011.708.293l4.764 4.764a.99.99 0 01.033.032l17.203 17.204a1 1 0 01-1.414 1.414L16.586 18zm-3.721 2.498a1 1 0 011.73 1.004 3 3 0 01-5.19 0 1 1 0 011.73-1.004 1 1 0 001.73 0z"
  }));
});

export default AlertDisable;
//# sourceMappingURL=alert-disable.svg.js.map
